module.exports = __webpack_public_path__ + "img/icon_ordernumber.26ab05dc.svg";